"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.tester.name': 'Nombre del Probador',
    'botTest.tester.model': 'Modelo de IA',
};
